import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
import { useContractModel } from '../contractParticularsModel'

export function DataTable({ goPageNav }) {
    const {t} = useTranslation()
    const { loadData, dataSource, selectedRowKeys, pgCfg, setSelectedRowKeys, loading, dictObj, initDict } = useContractModel()


    useEffect(() => {
        initDict();
        loadData();
    }, [])

    const onRow = (record) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([record]);
        }
    };

    const columns = [
        {
            title:  t(`contractManagement.view.DataTable.序号`),
            width: 40,
            render: (t, r, i) => `${i + 1}`,
            fixed: 'left'
        }, {
            title:  t(`contractManagement.view.DataTable.合约单号`),
            width: 120,
            dataIndex: 'signCode',
            fixed: 'left',
            render: (text, record) => <YhTooltip text={text} onClick={() => { goPageNav("edit", record.id) }} />,
        }, {
            title:  t(`contractManagement.view.DataTable.签约类型`),
            width: 80,
            dataIndex: 'signType',
            fixed: 'left',
            render: (text) => { if (text === '046001') { return text =   t(`contractManagement.view.DataTable.大包`) } else { return text =   t(`contractManagement.view.DataTable.月结`) } }

        }, {
            title:  t(`contractManagement.view.DataTable.大包模式`),
            width: 80,
            dataIndex: 'bigBagMode',
            fixed: 'left',
            render: (text) => <>{dictObj.bigBagMode[text]}</>,
        }, {
            title:  t(`contractManagement.view.DataTable.客户名称`),
            width: 80,
            dataIndex: 'customerName',
            render: (text) => <YhTooltip text={text} maxWidth={300} />,
        },
        {
            title:  t(`contractManagement.view.DataTable.签约实体`),
            width: 80,
            dataIndex: 'signBusinessEntityName',
            render: (text) => <YhTooltip text={text} maxWidth={300} />,
        },

        {
            title:  t(`contractManagement.view.DataTable.单据金额`),
            width: 80,
            dataIndex: 'totalAmount',
            render: (text) => text.toFixed(2)
        }, {
            title:  t(`contractManagement.view.DataTable.已收金额`),
            width: 80,
            dataIndex: 'paidAmount',
            render: (text) => text.toFixed(2)


        }, {
            title:  t(`contractManagement.view.DataTable.应收金额`),
            width: 80,
            dataIndex: 'payableAmount',
            render: (text) => text.toFixed(2)

        }, {
            title:  t(`contractManagement.view.DataTable.维修单数`),
            width: 80,
            dataIndex: 'orderNum',

        },
        {
            title:  t(`contractManagement.view.DataTable.创建人`),
            width: 80,
            dataIndex: 'createUserName',
        },
        {
            title:  t(`contractManagement.view.DataTable.创建时间`),
            width: 140,
            dataIndex: 'createTime',
        },
        {
            title:  t(`contractManagement.view.DataTable.所属机构`),
            width: 140,
            dataIndex: 'organName',
        },
    ];

    return (
        <Table
            dataSource={dataSource}
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `${ t(`contractManagement.view.DataTable.共`)}${pgCfg.total}${ t(`contractManagement.view.DataTable.条`)}`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize });
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.id]);
            //     }
            // })}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}